<template>
  <v-card class="v-modal-new-window analyzed-dialog analyzed-view-dialog">
    <!-- [S]  Popup title-->
    <v-card-title class="headline white--text" primary-title>
      {{ pageTitle }}
    </v-card-title>
    <!-- [E]  Popup title-->

    <!-- [S]  Info-->
    <v-card-text class="info-section child-table-top-header ">
      <v-row class="analys-top-tool">
        <v-col cols="12" sm="3" class="pa-0 pt-0 pl-3">
          <span class="float-left"
            ><span class="subheader-text"
              >{{ this.params.STR_SNDR }} - {{ this.params.STR_RCVR }} -
            </span>
            <span class="subheader-message">{{ this.params.MSG_ID }}</span></span
          >
        </v-col>
        <v-col cols="12" sm="9" class="pa-0 pl-3 pt-0 pr-3">
          <span class="float-left"><span class="edi-gridheader-text">Layout View</span></span>
          <span class="float-right"
            ><span class="gridheader-text">Total analyzed EDI File : </span
            ><span class="total-text">{{ this.params.MSG_CNT }}</span></span
          >
        </v-col>
      </v-row>
    </v-card-text>
    <!-- [E]  Info-->

    <v-card-text class="data-section">
      <!-- [S]  Tree view and table-->
      <v-row class="ma-0 edi-data-mb">
        <v-col cols="12" class="pt-0 pb-0 pd-grid-left">
          <v-row>
            <!-- [S]  Tree view-->
            <v-col cols="12" sm="3" class="pt-0 pr-3 pb-0">
              <v-row class="tree-panel edi-wrap-content-left">
                <v-col cols="12" class="text-left pa-0 pr-3  pb-2">
                  <v-btn
                    x-small
                    tile
                    @click="expandAllTreeView"
                    class="expand-all-tree-view-button btn-height-custom"
                    dark
                    >{{ !expandAll ? 'Expand All' : 'Collapse All' }}</v-btn
                  >
                </v-col>
                <v-col cols="12" class="pb-1 col-tree">
                  <v-row class="no-gutters">
                    <v-treeview
                      v-model="tree"
                      :open="open"
                      :items="treeItems"
                      ref="analyzedTreeView"
                      class="analyzedTree"
                      activatable
                      open-on-click
                    >
                      <template v-slot:label="{ item, open }">
                        <div
                          v-if="!item.disabled && typeof item.children != 'undefined'"
                          class="group-has-children-item"
                        >
                          <v-icon small class="mr-1">fa fa-object-group</v-icon>
                          <span class="group-name">{{ item.seg }}</span> - {{ item.req }} -
                          {{ item.loop }}
                        </div>
                        <div
                          v-if="item.disabled && typeof item.children != 'undefined'"
                          class="group-no-children-item"
                        >
                          <v-icon small color="#b9bbb7" class="mr-1">fa fa-object-group</v-icon>
                          <span class="group-name">{{ item.seg }}</span> - {{ item.req }} -
                          {{ item.loop }}
                        </div>
                        <div
                          v-if="typeof item.children == 'undefined' && !item.disabled"
                          class="child-visible-item"
                          @click="itemClick(item)"
                        >
                          <v-icon small class="mr-1">fa fa-cube</v-icon>
                          <span class="child-item">{{ item.seg }}</span> - {{ item.req }} -
                          {{ item.loop }} - {{ item.dataname }}
                        </div>
                        <div
                          v-if="typeof item.children == 'undefined' && item.disabled"
                          class="child-invisible-item"
                        >
                          <v-icon small color="#dbd7db" class="mr-1">fa fa-cube</v-icon>
                          <span class="child-item">{{ item.seg }}</span> - {{ item.req }} -
                          {{ item.loop }} - {{ item.dataname }}
                        </div>
                      </template>
                    </v-treeview>
                  </v-row>
                </v-col>
              </v-row>
            </v-col>
            <!-- [E]  Tree view-->

            <!-- [S]  Table-->
            <v-col cols="12" sm="9" class="pt-0 pl-5 pb-0 edi-table-section">
              <v-row class="table-panel ml-0 edi-wrap-content-right">
                <v-col class="pa-0" cols="12">
                  <v-row class="analys-top-tool child-table-top-header">
                    <v-col cols="12" sm="3" class="text-left pb-0">
                      <div>
                        <v-icon :disabled="gridListViewBtn" @click="changeView">fas fa-th</v-icon>
                        <span class="vertical-line"></span>
                        <v-icon :disabled="!gridListViewBtn" @click="changeView">
                          fa-th-list</v-icon
                        >
                      </div>
                    </v-col>
                    <v-col cols="12" sm="6" class="text-right pb-0">
                      <div>
                        <span class="filter-text">Not Used</span>
                        <toggle-button
                          v-model="filterQuery.not_used"
                          :labels="true"
                          :sync="true"
                          @change="toggleFilter"
                          :height="15"
                          :color="{
                            checked: this.checkedColor,
                            unchecked: unCheckedColor,
                            disabled: '#CCCCCC',
                          }"
                          :switch-color="{
                            checked: this.toggleButton,
                            unchecked: this.toggleButton,
                          }"
                        />
                        <!-- <span class="filter-text">One Value</span>
                        <toggle-button v-model="filterQuery.one_value" :labels="true" :sync="true" @change="toggleFilter" :height="15"
                        :color="{checked: this.checkedColor, unchecked: this.unCheckedColor, disabled: '#CCCCCC'}"
                        :switch-color="{checked: this.toggleButton, unchecked: this.toggleButton}"/> -->
                        <span class="filter-text">Qualifier</span>
                        <toggle-button
                          v-model="filterQuery.qualifier"
                          :labels="true"
                          :sync="true"
                          @change="toggleFilter"
                          :height="15"
                          :color="{
                            checked: this.checkedColor,
                            unchecked: this.unCheckedColor,
                            disabled: '#CCCCCC',
                          }"
                          :switch-color="{
                            checked: this.toggleButton,
                            unchecked: this.toggleButton,
                          }"
                        />
                      </div>
                    </v-col>
                    <v-col class="pr-4 pb-0" cols="12" sm="3">
                      <v-text-field
                        v-model="searchData"
                        @input="toggleFilter"
                        class="search-matched-map-list-button custom-form-component search-button edi-analyzed-search"
                        placeholder="Search"
                        append-icon="fas fa-search"
                        outlined
                        height="30"
                        dense
                        solo
                        hide-details
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </v-col>
                <v-col class="pa-0 pb-1" cols="12" sm="12">
                  <v-row class="pa-4 pt-0 pb-0">
                    <v-table
                      :height="530"
                      :isMinHeight="isMinHeight"
                      :title-row-height="30"
                      :table-bg-color="'#fafcff'"
                      :title-rows="titleRows"
                      :columns="columns"
                      :table-data="tableData"
                      :column-cell-class-name="columnCellClass"
                      :errorContent="'No matching records found'"
                      :is-loading="showLoading"
                      :select-all="selectALL"
                      :select-change="selectChange"
                      :lazy-loading="lazy_loading"
                      class="analyzed-view-table"
                      ref="edi_analyzed_table"
                      is-horizontal-resize
                      row-hover-color="#eee"
                      row-click-color="#edf7ff"
                      width="100%"
                    ></v-table>
                  </v-row>
                </v-col>
              </v-row>
            </v-col>
            <!-- [E]  Table-->
          </v-row>
        </v-col>
      </v-row>
      <!-- [E]  Tree view and table-->

      <!-- [S]  Buttons-->
      <v-row class="ma-0">
        <v-col class="pa-0 text-left" cols="3"> </v-col>
        <v-col class="pa-0" cols="9">
          <v-row class="ma-0">
            <v-col class="pr-0 pt-0 pb-0 text-left create-layout-btn pl-5" cols="6">
              <!-- 203705 08/06/2020 : Show "Create Layout" Button if only for Status is "Uploaded(UPLD)" -->
              <v-tooltip top :disabled="!isEnableCreateLayout" :max-width="tooltipWidth">
                <template v-slot:activator="{ on }">
                  <div v-on="on" class="btn-tooltip">
                    <v-btn
                      v-if="mode != 'MergeView' && params.PRCS_STS == 'UPLD'"
                      class="btn btn-search"
                      tile
                      color="#0082ba"
                      dark
                      @click="createLayout"
                      :disabled="isEnableCreateLayout"
                    >
                      <v-icon small color="white" class="mr-1">fa fa-object-ungroup</v-icon>
                      Create Layout
                    </v-btn>
                  </div>
                </template>
                <span>{{ $t('msg.customerDataAnalysis.createLayoutTooltipMsg') }}</span>
              </v-tooltip>
            </v-col>
            <v-col class="pa-0 text-right" cols="6">
              <v-btn
                class="ma-0 btn btn-popup btn-delete"
                tile
                dark
                @click="closeWindow('btn-close')"
              >
                <!-- <v-icon small color="white" class="mr-1">fa fa-times</v-icon> -->
                Close
              </v-btn>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <!-- [E]  Buttons-->
    </v-card-text>
    <dialogWindow
      ref="processStatusCheck"
      size="max"
      title="Process Status Check"
      detail="Please check process Status Check!
                Except 'Uploaded' and 'Layout created' You cannnot use"
      color="validation"
    >
    </dialogWindow>
    <dialogWindow
      ref="checkselectedCnt"
      size="max"
      title="Selected Item check"
      detail="There is no checked Item!"
      color="validation"
    >
    </dialogWindow>
    <dialogWindow
      ref="processInserted"
      size="max"
      title="Process Inserted"
      detail="Layout has been created successfully!"
      color="success"
      @select-ok="closeWindow('btn-close')"
    >
    </dialogWindow>
  </v-card>
</template>

<script>
/* globals Store */
/* Remove unuse code
import { debounce } from "lodash";
import { get } from "lodash";
import { deleteDateFormatStr } from '@/vue-dlb/utils/util';
import { beforeOneMonth } from '@/vue-dlb/utils/util';
import {
  showSuccessMessage,
  showErrorMessage,
  showProgress,
  hideProgress
} from "@/vue-dlb/utils/sys-util.js";
*/
import { mapState } from 'vuex';
import { MsgTreeParser } from '@/vue-dlb/utils/msgtree_parser';
import $ from 'jquery';
import dialogWindow from '@/vue-dlb/components/NewDialog.vue';
import cfg from '@/vue-caas/config/config.js';
import idb from '@/vue-dlb/utils/idb';

const msgtreeParser = new MsgTreeParser();

export default {
  components: {
    dialogWindow,
  },
  data() {
    return {
      /* Remove unuse code
      switch_used: false,
      switch_text: false,
      switch_must: false,
      head_title: '',
      findFilterValue: '',
      numberFormatter: new Intl.NumberFormat('en-US'),
      */
      selectedCheckBoxCnt: 0,
      tooltipWidth: 300,
      pageTitle: 'EDI Analyzed View',
      checkedColor: '#75C7AF',
      unCheckedColor: '#BFCBD9',
      toggleButton: '#FFFFFF',
      gridListViewBtn: false,
      segmentFilterValue: '',
      tree: [],
      treeItems: [],
      lazy_loading: true,
      filterQuery: {
        not_used: false,
        // one_value : false,
        qualifier: false,
      },
      expandAll: false,
      dialog: false,
      showLoading: false,
      query: '',
      open: ['ROOT'],
      searchMessageItems: {
        header: [
          'CUST_ID',
          'STR_SNDR',
          'STR_RCVR',
          'MSG_ID',
          'MSG_VER',
          'DAT_TYPE',
          'FR_DAT',
          'TO_DAT',
          'PRCS_STS',
          'LAY_PRCS_NO',
          'ALIAS',
        ],
        data: [
          {
            CUST_ID: '',
            STR_SNDR: '',
            STR_RCVR: '',
            MSG_ID: '',
            MSG_VER: '',
            DAT_TYPE: '',
            FR_DAT: '',
            TO_DAT: '',
            PRCS_STS: '', // in case of DataAnalysis Tree selects all status data
            LAY_PRCS_NO: '',
            ALIAS: '',
          },
        ],
      },
      searchLayoutItems: {
        header: ['MSG_ID', 'MSG_VER', 'LAY_PRCS_NO'],
        data: [
          {
            MSG_ID: '',
            MSG_VER: '',
            LAY_PRCS_NO: '',
          },
        ],
      },
      insertLayoutMaster: {
        header: [
          'CUST_ID',
          'STR_SNDR',
          'STR_RCVR',
          'MSG_STD',
          'MSG_ID',
          'MSG_VER',
          'DAT_TYPE',
          'FR_DAT',
          'TO_DAT',
          'PRCS_STS',
          'LAY_PRCS_NO',
        ],
        data: [
          {
            CUST_ID: '',
            STR_SNDR: '',
            STR_RCVR: '',
            MSG_STD: '',
            MSG_ID: '',
            MSG_VER: '',
            DAT_TYPE: '',
            FR_DAT: '',
            TO_DAT: '',
            PRCS_STS: '',
            LAY_PRCS_NO: '',
          },
        ],
      },
      insertLayoutData: {
        header: [
          'SYSSTATUS',
          'ROWID',
          'ELEM_VAL',
          'GRP',
          'ELEM_ID',
          'CNT',
          'CODE_YN',
          'SELE_YN',
          'SEG_ELEM',
          'ESDATAELEM',
          'ESDATANAME',
          'EFDHTYPE',
          'EFLOOP_INDEX',
          'ESNOELEM',
          'POS',
          'EFSEGMENT_ID',
          'EFMAX_USE',
          'ESREQUIRE',
          'EFDHMAXIMUM',
          'EFLOOP_LEVEL',
          'ELEM_NO',
          'SEQ',
          'EFLOOP_ID',
          'EFCODEDEFIN',
        ],
        data: [],
      },
      titleRows: [
        [
          { fields: ['SELE_YN'], title: '', titleAlign: 'center', rowspan: 1 },
          {
            fields: ['EFSEGMENT_ID'],
            title: 'Seg.',
            titleAlign: 'center',
            rowspan: 1,
            newprop: 'newprop',
          },
          { fields: ['ESDATAELEM'], title: 'Element', titleAlign: 'center', rowspan: 1 },
          { fields: ['ESDATANAME'], title: 'Element Name', titleAlign: 'center', rowspan: 1 },
          { fields: ['ESREQUIRE'], title: 'Req', titleAlign: 'center', rowspan: 1 },
          { fields: ['EFDHTYPE'], title: 'Type', titleAlign: 'center', rowspan: 1 },
          { fields: ['EFDHMAXIMUM'], title: 'Size', titleAlign: 'center', rowspan: 1 },
          { fields: ['ELEM_VAL'], title: 'Value', titleAlign: 'center', rowspan: 1 },
          { fields: ['CNT'], title: 'Count', titleAlign: 'center', rowspan: 1 },
          { fields: ['EFCODEDEFIN'], title: 'Value Info', titleAlign: 'center', rowspan: 1 },
          { fields: ['ELEM_ID'], title: 'Element Biz. ID', titleAlign: 'center', rowspan: 1 },
          { fields: ['SEG_ELEM'], title: 'MIG Name', titleAlign: 'center', rowspan: 1 },
        ],
      ],
      columns: [
        {
          field: 'SELE_YN',
          width: 60,
          titleAlign: 'center',
          columnAlign: 'center',
          type: 'selection',
        },
        { field: 'EFSEGMENT_ID', width: 60, columnAlign: 'center' },
        { field: 'ESDATAELEM', width: 80, columnAlign: 'center' },
        { field: 'ESDATANAME', width: 180, columnAlign: 'left' },
        { field: 'ESREQUIRE', width: 60, columnAlign: 'center' },
        { field: 'EFDHTYPE', width: 60, columnAlign: 'center' },
        { field: 'EFDHMAXIMUM', width: 60, columnAlign: 'center' },
        { field: 'ELEM_VAL', width: 80, columnAlign: 'center' },
        { field: 'CNT', width: 60, columnAlign: 'center' },
        { field: 'EFCODEDEFIN', width: 150, columnAlign: 'center' },
        { field: 'ELEM_ID', width: 110, columnAlign: 'center' },
        { field: 'SEG_ELEM', width: 113, columnAlign: 'center' },
      ],
      tableData: [],
      idbData: [],
      idbDataSearch: [],
      searchData: '',
      isMinHeight: true,
    };
  },

  computed: {
    ...mapState('layout', {
      segItems: 'segItems',
      segTableItems: 'segTableItems',
      layoutWindowParam: 'layoutWindowParam',
    }),
    /*  Remove unuse code
    textColor() {
      return this.color + '--text';
    },
    maxWidth() {
      return this.size == 'min' ? 250 : 350;
    },
    headers() {
      return [
        {text : "", value: "SELE_YN"},
        {text : "Seg.", value: "EFSEGMENT_ID"},
        {text : "Element", value: "ESDATAELEM"},
        {text : "Element Name", value: "ESDATANAME"},
        {text : "Req.", value: "ESREQUIRE"},
        {text : "Type", value: "EFDHTYPE"},
        {text : "Size", value: "EFDHMAXIMUM"},
        {text : "Value", value: "ELEM_VAL", filter: this.valueTypeFilter, },
        {text : "Count", value: "CNT", filter: this.oneValueFilter, },
        {text : "Value Info.", value: "EFCODEDEFIN", width:"100px"},
        {text : "Element Biz. ID", value: "ELEM_ID", filter: this.segmentFilter, width:"200px"},
        {text : "MIG Name", value: "SEG_ELEM", width:"100px"}
      ]
    },
    */
    isEnableCreateLayout() {
      let checkData = [];
      let falseCheckedCnt = 0;
      this.tableData.forEach((element) => {
        if (element._checked) {
          checkData.push(element);
        }
      });
      if (checkData.length > 0) {
        return false;
      }
      return true;
    },
  },
  watch: {
    dialog() {
      this.dialog ? this.$emit('disable-close') : this.$emit('enable-close');
    },
  },
  mounted() {
    setTimeout(() => {
      this.treeItems = msgtreeParser.parse(this.segItems)[0].children;
    }, 300);
    setTimeout(() => {
      document.getElementsByClassName('overlay-background')[0].style.display = 'none';
    }, 1000);
  },
  methods: {
    createCheckbox() {
      this.tableData = [];
      this.idbData.forEach((rowdata) => {
        if (rowdata.SELE_YN === 'Y') {
          this.tableData.push(Object.assign(rowdata, { _checked: true }));
          this.selectedCheckBoxCnt++;
        } else {
          this.tableData.push(Object.assign(rowdata, { _checked: false }));
          this.selectedCheckBoxCnt--;
        }
      });
    },
    selectALL(selection) {
      this.tableData = [];
      this.idbData.forEach((rowdata) => {
        if (selection.length > 0) {
          this.tableData.push(Object.assign(rowdata, { _checked: true }, { SELE_YN: 'Y' }));
        } else {
          this.tableData.push(Object.assign(rowdata, { _checked: false }, { SELE_YN: 'N' }));
        }
      });
      this.selectedCheckBoxCnt = selection.length;
    },
    selectChange(selection, rowData) {
      let index = 0;
      index = this.tableData.findIndex((element) => element.ROWID === rowData.ROWID);

      if (rowData.SELE_YN === 'Y') {
        // Y->N
        Object.assign(rowData, { _checked: false }, { SELE_YN: 'N' });
        this.selectedCheckBoxCnt--;
      } else {
        // N->Y
        Object.assign(rowData, { _checked: true }, { SELE_YN: 'Y' });
        this.selectedCheckBoxCnt++;
      }
      this.tableData.splice(index, 1, rowData);
    },
    removeDialog(dialog) {
      dialog.id = this.id;
      this.closeDialog(dialog);
    },
    selectDialog(obj) {
      this.dragStart(obj);
    },
    dialogDragEnd(obj) {
      this.dragEnd(obj);
    },
    selectOk() {
      this.$emit('select-ok', this.dataValue);
      this.dialog = false;
    },
    selectClose() {
      this.$emit('select-close', this.dataValue);
      this.dialog = false;
    },
    expandAllTreeView() {
      this.expandAll = !this.expandAll;
      if (this.expandAll) {
        this.$refs.analyzedTreeView.updateAll(this.expandAll);
      } else {
        this.$set(this, 'treeItems', []);
        this.$nextTick(() => {
          this.$set(this, 'treeItems', msgtreeParser.parse(this.segItems)[0].children);
        });
      }
    },
    /*  Remove unuse code
    formatNumber(num) {
      return this.numberFormatter.format(num);
    },
    onChangeNotUsed () {
      console.log('onChangeNotUsed clicked !')
       this.filterQuery.qualifier = false;
      //  this.filterQuery.one_value = false;
    },
    segmentFilter(value) {
      // If this filter has no value we just skip the entire filter.
      if (!this.segmentFilterValue) {
        return true;
      }

      // Check if the current loop value (The dessert name)
      // partially contains the searched word.
      return value.toLowerCase().includes(this.segmentFilterValue.toLowerCase());
    },
    valueTypeFilter(value) {
      let retVal = true;

      // If this filter has no value we just skip the entire filter.
      if (this.filterQuery.not_used && !this.filterQuery.qualifier) {
        return true;
      }

      if(!value) return false;

      if(!this.filterQuery.not_used) {
        if( value.toLowerCase().includes('not used')) {
          retVal = false;
        }
      }

      if(this.filterQuery.qualifier) {
        if( value.toLowerCase().includes('text')) {
          retVal = false;
        }
      }

      return retVal;
    },
     // oneValueFilter(value) {
    //   let retVal = true;

    //   // If this filter has no value we just skip the entire filter.
    //   if (!this.filterQuery.one_value) {
    //     return true;
    //   }

    //   if(!value) return false;

    //   if(this.filterQuery.one_value) {
    //     if(this.params.MSG_CNT > value) {
    //       retVal = false;
    //     }
    //   }

    //   return retVal;
    // },
    */
    async itemClick(item) {
      await this.$nextTick(() => {
        this.showLoading = true;
        this.$refs.edi_analyzed_table.$forceUpdate();
      });
      await this.delay(100);
      await this.$nextTick();
      this.lazy_loading = false;
      await this.$nextTick();
      this.showLoading = false;
      setTimeout(() => {
        for (let i = 0; i < this.idbData.length; i++) {
          if (this.idbData[i].EFSEGMENT_ID === item.seg) {
            $('.analyzed-view-table .v-table-rightview-special-border').scrollTop(i * 40);
            return;
          }
        }
        alert('Item not exist in table');
      }, 300);
    },
    delay: (ms) =>
      new Promise((res) => {
        setTimeout(res, ms);
      }),

    async loadIt() {
      this.isLoading = true;

      // wait for vdom -> dom
      await this.$nextTick();

      // force browser to rerender dom
      // by requesting some property
      // from newly created node
      let width = this.$refs.hey.width;

      // wait for some time, of course
      // higher than monitor refresh rate
      await this.delay(40);

      this.isDone = true;
      this.isLoading = false;
    },
    columnCellClass(rowIndex, columnName, rowData) {
      if (rowData.ELEM_VAL != null && rowData.ELEM_VAL.toLowerCase() == 'not used') {
        return 'not-used-col';
      }
      if (columnName == 'EFSEGMENT_ID') {
        return 'seg-col';
      }
      return `${columnName}-col`;
    },
    changeView() {
      this.gridListViewBtn = !this.gridListViewBtn;
    },
    toggleFilter() {
      //Search field blank
      let dataSearh = this.idbDataSearch;
      let query_not_used = this.filterQuery.not_used;
      let query_qualifier = this.filterQuery.qualifier;
      let listResult = [];
      //turn off all -> showall except not usesd
      if (!query_not_used && !query_qualifier) {
        let i = 0;
        listResult = dataSearh.filter((item) => {
          if (item.ELEM_VAL != null) {
            if (item.ELEM_VAL.toLowerCase() != 'not used') {
              i++;
              return true;
            }
          }
          return false;
        });
        if (this.searchData != '') {
          listResult = this.searchFilterData(listResult);
        }
        console.log('FIRSTlOAD', listResult);
      }
      //turn on all -> showall except text
      else if (query_not_used && query_qualifier) {
        listResult = dataSearh.filter((item) => {
          if (item.ELEM_VAL != null) {
            if (item.ELEM_VAL.toLowerCase() != 'text') {
              return true;
            }
          }
          return false;
        });
        if (this.searchData != '') {
          listResult = this.searchFilterData(listResult);
        }
      } else if (query_not_used && !query_qualifier) {
        listResult = this.idbDataSearch;
        if (this.searchData != '') {
          listResult = this.searchFilterData(listResult);
        }
      } else if (!query_not_used && query_qualifier) {
        listResult = dataSearh.filter((item) => {
          if (item.ELEM_VAL != null) {
            if (
              item.ELEM_VAL.toLowerCase() != 'text' &&
              item.ELEM_VAL.toLowerCase() != 'not used'
            ) {
              return true;
            }
          }
          return false;
        });
        if (this.searchData != '') {
          listResult = this.searchFilterData(listResult);
        }
      }
      this.idbData = listResult;
      this.tableData = this.idbData;
    },
    searchFilterData(data) {
      let result = data.filter((item) => {
        for (const prop in item) {
          if (typeof item[prop] == 'string') {
            let propValue = item[prop].toLowerCase();
            let queryValue = this.searchData.toLowerCase();
            if (propValue.startsWith(queryValue)) {
              return true;
            }
          } else if (typeof item[prop] == 'number') {
            let propValue = item[prop].toString().toLowerCase();
            let queryValue = this.searchData.toLowerCase();
            if (propValue.startsWith(queryValue)) {
              return true;
            }
          }
        }
        return false;
      });
      return result;
    },
    onFilterAnalyzed(str) {
      this.showLoading = true;
      setTimeout(() => {
        Store.dispatch('layout/setFilterAnalyzed', {
          query: str,
          filterQuery: this.filterQuery,
        }).then(() => {
          this.tableData = this.segTableItems;
          this.showLoading = false;
        });
      }, 300);
    },
    getMessageData() {
      this.searchMessageItems.data[0].CUST_ID = this.params.CUST_ID;
      this.searchMessageItems.data[0].STR_SNDR = this.params.STR_SNDR;
      this.searchMessageItems.data[0].STR_RCVR = this.params.STR_RCVR;
      this.searchMessageItems.data[0].MSG_ID = this.params.MSG_ID;
      this.searchMessageItems.data[0].MSG_VER = this.params.MSG_VER;
      this.searchMessageItems.data[0].DAT_TYPE = this.params.DAT_TYPE;
      this.searchMessageItems.data[0].FR_DAT = this.params.FR_DAT;
      this.searchMessageItems.data[0].TO_DAT = this.params.TO_DAT;
      this.searchMessageItems.data[0].PRCS_STS = this.params.PRCS_STS;
      this.searchMessageItems.data[0].LAY_PRCS_NO = '';
      this.searchMessageItems.data[0].ALIAS = '';

      Store.dispatch('layout/getMessageTreeData', this.searchMessageItems).then(() => {
        console.log('--------- Finished to process ----------');
        this.buildTreeItems();
        Store.dispatch('layout/getAnalyzedDataIndexDb', this.searchMessageItems).then(() => {
          //get Data from indexDB
          idb.getDataByTrName('getAnalyzedData').then((value) => {
            this.idbData = value[0].DataSets[0].DataRows;
            this.idbDataSearch = value[0].DataSets[0].DataRows;
            this.toggleFilter();
            this.createCheckbox();
          });
        });
      });
    },
    buildTreeItems() {
      this.treeItems = msgtreeParser.parse(this.segItems)[0].children;
      console.log('--------- Return Result ----------');
    },
    getLayoutData() {
      this.searchLayoutItems.data[0].MSG_ID = this.params.MSG_ID;
      if (this.params.MSG_VER.length < 5) {
        this.searchLayoutItems.data[0].MSG_VER = 'UN' + this.params.MSG_VER;
      } else {
        this.searchLayoutItems.data[0].MSG_VER = this.params.MSG_VER;
      }
      this.searchLayoutItems.data[0].LAY_PRCS_NO = this.params.LAY_PRCS_NO;
      Store.dispatch('layout/getLayoutTreeData', this.searchLayoutItems).then(() => {
        console.log('--------- Finished to process ----------');
        this.buildTreeItems();
        Store.dispatch('layout/getLayoutDataIndexDb', this.searchLayoutItems).then(() => {
          //get Data from indexDB
          idb.getDataByTrName('getLayoutData').then((value) => {
            console.log('--------', value);
            this.idbData = value[0].DataSets[0].DataRows;
            this.idbDataSearch = value[0].DataSets[0].DataRows;
            this.toggleFilter();
            this.createCheckbox();
          });
        });
      });
    },
    createLayout() {
      console.log('--------- createLayout ----------');
      if (this.params.PRCS_STS === 'LAYO' || this.params.PRCS_STS === 'UPLD') {
        this.insertLayoutMaster.data[0].CUST_ID = this.params.CUST_ID;
        this.insertLayoutMaster.data[0].STR_SNDR = this.params.STR_SNDR;
        this.insertLayoutMaster.data[0].STR_RCVR = this.params.STR_RCVR;
        this.insertLayoutMaster.data[0].MSG_STD = this.params.MSG_STD;
        this.insertLayoutMaster.data[0].MSG_ID = this.params.MSG_ID;
        this.insertLayoutMaster.data[0].MSG_VER = this.params.MSG_VER;
        this.insertLayoutMaster.data[0].DAT_TYPE = this.params.DAT_TYPE;
        this.insertLayoutMaster.data[0].FR_DAT = this.params.FR_DAT;
        this.insertLayoutMaster.data[0].TO_DAT = this.params.TO_DAT;
        this.insertLayoutMaster.data[0].PRCS_STS = this.params.PRCS_STS;
        this.insertLayoutMaster.data[0].LAY_PRCS_NO = this.params.LAY_PRCS_NO;
        this.insertLayoutData.data = [];
        let falseCheckedCnt = 0;
        this.tableData.forEach((element) => {
          delete element._checked;
          this.insertLayoutData.data.push(element);
        });
        var insertPayload = [this.insertLayoutMaster, this.insertLayoutData];
        if (this.selectedCheckBoxCnt > 0) {
          Store.dispatch('layout/createLayout', insertPayload).then(() => {
            console.log('--------- Inserted ----------');
            this.$refs.processInserted.dialog = true;
          });
        } else {
          this.$refs.checkselectedCnt.dialog = true;
        }
      } else {
        this.$refs.processStatusCheck.dialog = true;
      }
    },
    // 203737 05/14/2021 Issue 16 New windown popup doesn't open
    closeWindow(type) {
      const message = {
        message: type,
      };
      if (window.opener && !window.opener.closed) {
        window.opener.postMessage(message, '*');
      }

      setTimeout(() => {
        window.close();
      }, 50);
    },
  },
  created() {
    console.log('--------- created ----------');
    console.log(window.theme);
    this.tooltipWidth = cfg.tooltipWidth;
    this.params = this.layoutWindowParam[this.$route.params.id];
    this.mode = window.mode;
    this.$vuetify.theme.dark = false;
    if (window.theme) {
      this.$vuetify.theme.dark = true;
      this.checkedColor = '#38BA5C';
      this.unCheckedColor = '#292C35';
      this.toggleButton = '#292C35';
    } else {
      this.$vuetify.theme.dark = false;
      this.checkedColor = '#75C791';
      this.unCheckedColor = '#D0D4DD';
      this.toggleButton = '#FFFFFF';
    }
    if (this.params.LAY_PRCS_NO != null && this.params.LAY_PRCS_NO.length > 0) this.getLayoutData();
    else this.getMessageData();
  },
};
</script>

<style>
.analyzed-view-table {
  width: 100% !important;
  min-height: 530px;
}
.analys-top-tool {
  padding: 0px !important;
}
.analys-top-tool div.col-12 {
  line-height: 29px;
}
.analys-top-tool .col-12 {
  padding: 0px 12px 8px 12px !important;
}
.pd-grid-left {
  padding-bottom: 8px !important;
}
.edi-gridheader-text {
  font-weight: 600;
  font-size: 14px;
  line-height: 19px;
  margin-left: 16px;
}
.vertical-line {
  border-left: 1px solid #18236d;
  border-bottom: 1px solid #18236d;
}
.edi-wrap-content-left {
  height: 600px !important;
  padding: 20px 15px 15px 15px !important;
  background: #fafcff;
  border: 1px solid #f0f7fb;
  box-sizing: border-box;
  border-radius: 3px;
}
.edi-wrap-content-right {
  height: 600px !important;
  padding: 20px 15px 15px 15px !important;
  background: #fafcff;
  border: 1px solid #f0f7fb;
  box-sizing: border-box;
  border-radius: 3px;
}
.col-tree {
  padding: 0px !important;
  margin: 0px !important;
}
/* .analyzed-dialog .tree-panel{
  background: #FAFCFF;
  border: none;
  }
  .edi-table-paddingb{
  padding-bottom: 10px;
  }
 */
.analyzed-view-dialog .analyzedTree.v-treeview {
  height: 510px !important;
  overflow-y: auto;
  max-height: 511px;
}
.btn-style {
  width: 100px !important;
  height: 30px !important;
}
.analyzed-view-dialog .data-section .edi-data-mb {
  margin-bottom: 10px !important;
}
.analyzed-view-table .v-table-btable .CNT-col div.v-table-body-cell {
  color: #0082ba !important;
}
.analyzed-view-table .v-table-btable .not-used-col div.v-table-body-cell {
  color: #c8c1c5 !important;
}
.analyzed-view-table .change_row {
  background: #fbbfc6 !important;
}
.analyzed-view-table .v-table-htable {
  background: #e4e6e8;
  font-size: 11px;
  line-height: 15px;
  color: black;
  font-weight: 600;
  font-style: normal;
  font-family: Open Sans;
}
.create-layout-btn {
  padding-left: 13px !important;
}
.analyzed-view-dialog .v-table-empty-scroll {
  min-height: 498px;
}
.v-table-header.v-table-title-class {
  width: 100% !important;
}

/* Theme Light */
.theme--light .analyzed-dialog .filter-text {
  color: #12083f;
}
.theme--light .v-icon.notranslate.mr-1.fa.fa.fa.fa-cube {
  color: #ba0070;
}
.theme--light .analyzed-dialog .subheader-message {
  color: #ba0070;
}
.theme--light .v-icon.notranslate.mr-1.fa.fa.fa.fa-object-group {
  color: #739e40;
}
.theme--light .analyzed-view-table .v-table-btable .seg-col div.v-table-body-cell {
  color: #ba0070;
}
.theme--light .edi-gridheader-text {
  color: #12083f;
}
.theme--light .fas.fa-th {
  content: '\f00b';
  font-size: 22px;
  margin: 0px 5px;
  color: #18236d;
}
.theme--light .fa-th-list {
  content: '\f00b';
  font-size: 22px;
  margin: 0px 5px;
  color: #18236d;
}

/* Theme Dark */
.theme--dark .analyzed-view-table .v-table-btable .seg-col div.v-table-body-cell {
  color: #ffa6db;
}
.theme--dark .analyzed-dialog .filter-text {
  color: #bbbbbb;
}
/* // 2021.11.26 203728 SPKA-274 modify paging */
/* .theme--dark .v-table-body-class::-webkit-scrollbar {
  width: 17px;
}
.theme--dark .v-table-body-class::-webkit-scrollbar-track  {
  background-color: #595B64;
}
.theme--dark .v-table-body-class::-webkit-scrollbar-thumb {
  background-color: #DEDFE0;
}
.theme--dark .v-table-body-class::-webkit-scrollbar-corner{
  background-color: #595B64;
} */
.theme--dark .analyzedTree::-webkit-scrollbar {
  width: 17px;
}
.theme--dark .analyzedTree::-webkit-scrollbar-track {
  background-color: #595b64;
}
.theme--dark .analyzedTree::-webkit-scrollbar-thumb {
  background-color: #dedfe0;
}
.theme--dark .analyzedTree::-webkit-scrollbar-corner {
  background-color: #595b64;
}
.theme--dark .group-has-children-item .group-name {
  color: #f1dd2c;
}
.theme--dark .child-visible-item .child-item {
  color: #ffa6db;
  font-weight: bold;
}
.theme--dark .analyzed-dialog .subheader-message {
  color: #ffa6db;
}
.theme--dark .v-icon.notranslate.mr-1.fa.fa.fa.fa-cube {
  color: #ffa6db;
}
.theme--dark .v-icon.notranslate.mr-1.fa.fa.fa.fa-object-group {
  color: #f1dd2c;
}
.theme--dark .text-right .v-switch-core {
  border: 1px solid #7b8189;
}
.theme--dark .text-right .v-switch-button {
  border: 1px solid #7b8189;
  top: -1px !important;
}
.theme--dark .analyzed-view-table .v-table-btable tr.v-table-row:hover {
  background: #243645 !important;
}
.theme--dark .v-table-empty-scroll::-webkit-scrollbar {
  width: 17px;
}
.theme--dark .v-table-empty-scroll::-webkit-scrollbar-track {
  background-color: #595b64;
}
.theme--dark .v-table-empty-scroll::-webkit-scrollbar-thumb {
  background-color: #dedfe0;
}
.theme--dark .v-table-empty-scroll::-webkit-scrollbar-corner {
  background-color: #595b64;
}
.theme--dark .edi-gridheader-text {
  color: #bbbbbb;
}
.theme--dark .fas.fa-th {
  font-size: 22px;
  margin: 0px 5px;
  color: #0082ba;
}
.theme--dark .fas.fa-th.v-icon--disabled,
.theme--dark .fa.fa-th-list.v-icon--disabled {
  content: '\f00a';
  font-size: 22px;
  margin: 0px 5px;
  color: #7d838d;
}
.theme--dark .fa.fa-th-list {
  font-size: 22px;
  margin: 0px 5px;
  color: #0082ba;
}
.theme--dark .vertical-line {
  border-left: 1px solid #0082ba;
  border-bottom: 1px solid #0082ba;
}
</style>
